<div class="container-xxl gx-0 gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="g-0 align-items-center">
        <div class="font-primary px-4 px-md-0 pe-md-4 pe-lg-14">
            <h1 class="mt-10 mt-md-5 fs-md-39 fs-29 fw-700 mb-5">{{ 'COMPLAINTS.title' | translate }}</h1>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.question.1' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.answer.1.1' | translate"></p>
            <ul class="dash">
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.list-line.1.1' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.list-line.1.2' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.list-line.1.3' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.list-line.1.4' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.list-line.1.5' | translate"></li>
            </ul>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.answer.1.2' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.question.2' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.answer.2.1' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.question.3' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.answer.3.1' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.requirements' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.requirements.list-text' | translate"></p>
            <ul class="disc">
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.requirements.list-line.1' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.requirements.list-line.2' | translate"></li>
                <li class="fs-16 mb-3" [innerHtml]="'COMPLAINTS.requirements.list-line.3' | translate"></li>
            </ul>
            <p class="fw-700 mb-3" [innerHtml]="'COMPLAINTS.requirements.warning' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.requirements.warning.text' | translate"></p>

            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.question.4' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.answer.4.1' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.deadline' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.deadline.text' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.notification' | translate"></p>
            <p class="mb-3" [innerHtml]="'COMPLAINTS.notification.text' | translate"></p>
            <p class="question fw-700 mb-3" [innerHtml]="'COMPLAINTS.declaration' | translate"></p>
            <p class="mb-5" [innerHtml]="'COMPLAINTS.declaration.text' | translate"></p>
        </div>
    </div>
</div>
